import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'sanitize',
    standalone: true,
})
export class SanitizePipe implements PipeTransform {
  constructor (private dom:DomSanitizer) {

  }
  transform(value: string) {
    return this.dom.bypassSecurityTrustHtml(value);
  }
}